import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar'
import { Separator } from '@/components/ui/separator'
import { getCookie } from '@/shared/lib/cookies'
import { cn } from '@/shared/lib/utils'
import { Outlet } from 'react-router-dom'
import { OperatorsAppSidebar } from '@/components/layout/operators-app-sidebar'
import { OperatorsProfileDropdown } from '@/components/layout/operators-profile-dropdown'

export function AuthenticatedLayout() {
  const defaultOpen = getCookie('sidebar_state') !== 'false'

  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <OperatorsAppSidebar />
      <SidebarInset
        className={cn(
          'relative flex w-full flex-1 flex-col bg-background',
          'md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ms-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ms-2'
        )}
      >
        <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger
            className="-ms-1"
            variant="outline"
            size="icon"
          />
          <Separator orientation="vertical" className="hidden h-6 md:block" />
          <div className="flex flex-1 items-center justify-end">
            <OperatorsProfileDropdown variant="default" />
          </div>
        </header>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
